"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _max2 = _interopRequireDefault(require("lodash/max"));
var _findIndex2 = _interopRequireDefault(require("lodash/findIndex"));
var _forEach2 = _interopRequireDefault(require("lodash/forEach"));
var _SourceItem = _interopRequireDefault(require("./SourceItem.js"));
var _Target = _interopRequireDefault(require("./Target.js"));
var _common = _interopRequireDefault(require("../../styles/common.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var DragDropElements = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(DragDropElements, _React$Component);
  function DragDropElements() {
    var _this;
    _classCallCheck(this, DragDropElements);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DragDropElements, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "_getNewElementId", function () {
      return ((0, _max2["default"])(_this.props.elements.map(function (element) {
        return element.id.value;
      })) || 0) + 1;
    });
    _defineProperty(_assertThisInitialized(_this), "_addElement", function (type, index) {
      var id = _this._getNewElementId();
      var element = _this.props.elementTypes[type];
      _this.props.elementFields[type].addField(_objectSpread(_objectSpread({}, element.initialValues), {}, {
        id: id
      }));
      _this.props.elements.addField(_objectSpread({
        id: id,
        type: type,
        label: element.defaultLabel || element.defaultLabel === '' ? element.defaultLabel : element.name,
        isExpanded: true
      }, _this.props.initialValues), index);
    });
    _defineProperty(_assertThisInitialized(_this), "_deleteElement", function (index) {
      var elements = _this.props.elements;
      var id = elements[index].id.value;
      var type = elements[index].type.value;
      var fieldIndex = (0, _findIndex2["default"])(_this.props.elementFields[type], function (item) {
        return item.id.value === id;
      });
      elements.removeField(index);
      _this.props.elementFields[type].removeField(fieldIndex);
    });
    _defineProperty(_assertThisInitialized(_this), "_getAddElementsButtons", function () {
      var buttons = [];
      (0, _forEach2["default"])(_this.props.elementTypes, function (item, type) {
        buttons.push( /*#__PURE__*/_react["default"].createElement(_SourceItem["default"], {
          key: type,
          constant: _this.props.constant,
          type: type,
          name: item.name,
          icon: item.icon,
          addElement: _this._addElement
        }));
      });
      return /*#__PURE__*/_react["default"].createElement("div", null, buttons);
    });
    _defineProperty(_assertThisInitialized(_this), "_handleDrop", function (type, id, idBefore) {
      var elements = _this.props.elements;
      var indexTo = elements.length;
      if (idBefore !== 0) {
        indexTo = (0, _findIndex2["default"])(elements, function (element) {
          return element.id.value === idBefore;
        });
      }
      if (id === 0) {
        _this._addElement(type, indexTo);
      } else {
        var indexFrom = (0, _findIndex2["default"])(elements, function (element) {
          return element.id.value === id;
        });
        if (indexFrom < indexTo) {
          indexTo--;
        }
        _this._moveInArray(elements, indexFrom, indexTo);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_moveInArray", function (array, indexFrom, indexTo) {
      if (indexFrom === indexTo) {
        return;
      }
      if (indexFrom < indexTo) {
        for (var i = indexFrom; i < indexTo; i++) {
          array.swapFields(i, i + 1);
        }
      } else {
        for (var _i = indexFrom; _i > indexTo; _i--) {
          array.swapFields(_i, _i - 1);
        }
      }
    });
    return _this;
  }
  _createClass(DragDropElements, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        constant = _this$props.constant,
        elements = _this$props.elements,
        elementFields = _this$props.elementFields,
        elementTypes = _this$props.elementTypes,
        renderElement = _this$props.renderElement,
        dragHint = _this$props.dragHint,
        blockType = _this$props.blockType,
        moveOnTab = _this$props.moveOnTab,
        extraProps = _this$props.extraProps;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Target["default"], {
        constant: constant,
        elements: elements,
        elementFields: elementFields,
        elementTypes: elementTypes,
        onDrop: this._handleDrop,
        deleteElement: this._deleteElement,
        renderElement: renderElement,
        dragHint: dragHint,
        blockType: blockType,
        addElement: this._addElement,
        moveOnTab: moveOnTab,
        extraProps: extraProps
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _common["default"].buttons
      }, this._getAddElementsButtons()));
    }
  }]);
  return DragDropElements;
}(_react["default"].Component);
_defineProperty(DragDropElements, "propTypes", {
  constant: _propTypes["default"].string.isRequired,
  elements: _propTypes["default"].array.isRequired,
  elementTypes: _propTypes["default"].object.isRequired,
  elementFields: _propTypes["default"].object.isRequired,
  renderElement: _propTypes["default"].func.isRequired,
  dragHint: _propTypes["default"].string,
  blockType: _propTypes["default"].string,
  initialValues: _propTypes["default"].object,
  moveOnTab: _propTypes["default"].bool,
  extraProps: _propTypes["default"].object
});
_defineProperty(DragDropElements, "defaultProps", {
  dragHint: 'Drag here',
  blockType: 'info',
  initialValues: {},
  moveOnTab: false,
  extraProps: {}
});